export class WorkingSlot {
     id = null;
     shiftWork = null;
     room = null;
     service = null;
     slotNumber = null;
     status = null;
     startTime = null;
     endTime = null;
 
     constructor(value) {
         Object.assign(this, value);
 
     }
 }